import React, { useEffect, useState } from 'react';
import { healthApi } from '../utils/api';
import { formatDateTimeInTimezone } from '../utils/dateUtils';

// Version info for deployment tracking.
// BUILD_DATE is baked in at build time as an ISO-8601 UTC instant (see the
// `build` script in package.json) so it can be rendered client-side in the
// store's configured timezone rather than frozen as a UTC string.
const VERSION = process.env.REACT_APP_VERSION || '1.276.0';
const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || new Date().toISOString();

/**
 * VersionFooter - Displays frontend + backend versions and deployment timestamp
 * Shows at bottom of pages for tracking and debugging. The backend version is
 * fetched live from /api/health so it's easy to confirm which build is deployed.
 */
const VersionFooter = ({ className = '' }) => {
  const [backendVersion, setBackendVersion] = useState(null);
  const [backendUnreachable, setBackendUnreachable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    healthApi
      .check()
      .then((data) => {
        if (!cancelled) setBackendVersion(data?.version || 'unknown');
      })
      .catch(() => {
        if (!cancelled) setBackendUnreachable(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={`mt-4 text-center ${className}`}>
      <p className="text-xs text-gray-400 font-mono">
        frontend v{VERSION} • {backendUnreachable ? 'backend unreachable' : `backend v${backendVersion || '…'}`} • {formatDateTimeInTimezone(BUILD_DATE)}
      </p>
    </div>
  );
};

export default VersionFooter;
